<template>
  <div class="row custom-row">
    <div class="col">
      <ul>
        <li v-for="(item, index) in alignment" :key="index" class="list-group-item list-group-item-action">
          <table class="table table-bordered table-striped">
            <colgroup>
              <col :style="{ width: '10%' }" />
              <col :style="{ width: '30%' }" />
              <col :style="{ width: '5%' }" />
              <col :style="{ width: '30%' }" />
            </colgroup>
            <thead>
              <tr class="table-primary">
                <th colspan="2" class="text-center">Invoice</th>
                <th class="text-center"></th>
                <th colspan="2" class="text-center">CCC One</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <b>Part #:</b>
                  <a href="#" class="custom-clipboard" @click.prevent="copy('partNumber', item.partNumber, index)">
                    <FontAwesomeIcon icon="fas fa-clipboard" />
                    <FontAwesomeIcon
                      v-if="isCopied('partNumber', index)"
                      icon="fas fa-check-circle"
                      :style="{ color: 'green', 'margin-left': '5px' }"
                    />
                  </a>
                </td>
                <td>{{ item.partNumber }}</td>
                <td class="text-center">
                  <FontAwesomeIcon icon="fas fa-equals" />
                  <FontAwesomeIcon icon="fas fa-greater-than" />
                </td>
                <td>{{ item.alignedTo?.partNumber }}</td>
              </tr>
              <tr>
                <td>Description:</td>
                <td>{{ item.description }}</td>
                <td class="text-center">
                  <FontAwesomeIcon icon="fas fa-equals" />
                  <FontAwesomeIcon icon="fas fa-greater-than" />
                </td>
                <td>{{ item.alignedTo?.description }}</td>
              </tr>
              <tr>
                <td>Type:</td>
                <td></td>
                <td class="text-center"></td>
                <td>{{ item.alignedTo?.partType }}</td>
              </tr>
              <tr>
                <td>
                  List $:
                  <a href="#" class="custom-clipboard" @click.prevent="copy('listAmount', item.listAmount, index)">
                    <FontAwesomeIcon icon="fas fa-clipboard" />
                    <FontAwesomeIcon
                      v-if="isCopied('listAmount', index)"
                      icon="fas fa-check-circle"
                      :style="{ color: 'green', 'margin-left': '5px' }"
                    />
                  </a>
                </td>
                <td>{{ item.listAmount }}</td>
                <td class="text-center">
                  <FontAwesomeIcon icon="fas fa-equals" />
                  <FontAwesomeIcon icon="fas fa-greater-than" />
                </td>
                <td>{{ item.alignedTo?.listPrice }}</td>
              </tr>
              <tr>
                <td>
                  <b>Cost $:</b>
                  <a href="#" class="custom-clipboard" @click.prevent="copy('extCost', item.alignedTo?.extCost, index)">
                    <FontAwesomeIcon icon="fas fa-clipboard" />
                    <FontAwesomeIcon v-if="isCopied('extCost', index)" icon="fas fa-check-circle" :style="{ color: 'green', 'margin-left': '5px' }" />
                  </a>
                </td>
                <td>
                  {{ item.costAmount }}
                </td>
                <td class="text-center">
                  <FontAwesomeIcon icon="fas fa-equals" />
                  <FontAwesomeIcon icon="fas fa-greater-than" />
                </td>
                <td>{{ item.alignedTo?.extCost }}</td>
              </tr>
              <tr>
                <td>Qty:</td>
                <td></td>
                <td class="text-center"></td>
                <td>{{ item.alignedTo?.quantity }}</td>
              </tr>
            </tbody>
          </table>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapState } from 'pinia'
import { invoiceStore } from '@/stores/invoice'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
export default {
  name: 'InvoiceTable',
  components: {
    FontAwesomeIcon
  },
  data() {
    return {
      detailColumnClass: 'custom-column-60',
      copiedCells: new Set()
    }
  },
  computed: {
    ...mapState(invoiceStore, ['loading', 'alignment']),
    tableColumnsName() {
      let columns = [
        {
          field: 'partNumber',
          label: 'Part #',
          sortable: false,
          class: 'custom-column-140'
        },
        {
          field: 'description',
          label: 'Description',
          sortable: false
        },
        {
          field: 'listAmount',
          label: 'List $',
          sortable: false,
          class: 'text-right custom-column-80'
        },
        {
          field: 'costAmount',
          label: 'Cost $',
          sortable: false,
          class: 'text-right custom-column-80'
        }
      ]
      return columns
    }
  },
  methods: {
    formatNumber(value) {
      return value ? value.toFixed(2) : '0.00'
    },
    isCopied(field, rowIndex) {
      return this.copiedCells.has(`${rowIndex}:${field}`)
    },
    extractNumber(str) {
      const match = str.match(/[\d,.]+/)
      return match ? parseFloat(match[0].replace(/,/g, '')) : null
    },
    copy(field, content, rowIndex) {
      if (content === undefined || content === null) {
        return
      }
      if (['listPrice', 'extCost', 'quantity'].includes(field)) {
        content = this.extractNumber(content.toString())
      }

      console.log('Copying:', { field, content, rowIndex })

      navigator.clipboard
        .writeText(content)
        .then(() => {
          // Mark the cell as copied
          const key = `${rowIndex}:${field}`
          this.copiedCells.add(key)
        })
        .catch((err) => console.error('Clipboard copy failed:', err))
    }
  }
}
</script>
<style scoped lang="scss">
.custom-row {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 550px;
  margin-right: 15px;
}
.custom-clipboard {
  position: relative;
  float: right;
}
</style>
